import { RATIOS, VALID_RECOMMENDATION_GENERATION_MIN_RATE } from 'constants/advanced';
import { formatNumberRoundDownToNearest, formatNumberRoundUpToNearest } from 'util/formatters/numberFormatter';
import type { ValidationRange } from 'store/types/types';

export const getAvgFixedPopulationRateMin = (RATE: ValidationRange) => {
  const avgFixedPopulationRateMin = formatNumberRoundDownToNearest(
    RATE?.max * RATIOS?.RECOMMENDATION_GENERATION_MIN_RATE, 1000
  );

  return avgFixedPopulationRateMin >= VALID_RECOMMENDATION_GENERATION_MIN_RATE
    ? avgFixedPopulationRateMin
    : VALID_RECOMMENDATION_GENERATION_MIN_RATE;
};

export const getAvgFixedPopulationRateMax = (RATE: ValidationRange) => {
  return formatNumberRoundUpToNearest(RATE?.max, 1000);
};
